export  const codeMap = {
    40001: '登录失效，请重新登录！',
    41001: '用户名密码错误！',
}
